import { render, staticRenderFns } from "./accessibility-role.vue?vue&type=template&id=399e74c5&"
import script from "./accessibility-role.vue?vue&type=script&lang=js&"
export * from "./accessibility-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports